import Immutable from 'seamless-immutable';
import clone from 'ramda/src/clone';
import propEq from 'ramda/src/propEq';
export var SubscriptionQuoteForPreview = function SubscriptionQuoteForPreview(subscriptionQuotes, quote) {
  return subscriptionQuotes && Immutable.asMutable(subscriptionQuotes.map(function (subscriptionQuote) {
    return Object.assign({}, subscriptionQuote, {
      items: subscriptionQuote.items.map(function (item) {
        return Object.assign({
          quoteItem: quote.Items.find(propEq(item.id, 'Id'))
        }, item);
      }).filter(function (item) {
        return item.quoteItem;
      })
    });
  }), {
    deep: true
  });
};
export var populateItemDetails = function populateItemDetails(items, cartItemDetails, quote) {
  var clonedItems = clone(items);
  return Immutable(clonedItems.map(function (item) {
    var cartItem = cartItemDetails && cartItemDetails.length ? cartItemDetails.find(function (cItem) {
      return cItem.PricingPlanId === item.PricingPlanId && cItem.ProductId === item.ProductId;
    }) : null;
    var quoteItem = quote && quote.Items && quote.Items.length ? quote.Items.find(function (qItem) {
      return qItem.Product.Id === item.ProductId && qItem.PricingPlan.Id === item.PricingPlanId;
    }) : null;
    if (cartItem) {
      item.Details = cartItem.Details;
      item = Object.assign({}, cartItem, item);
    } else {
      if (quoteItem) {
        item.Details.PricingPlan = Object.assign({}, item.Details.PricingPlan, quoteItem.PricingPlan);
        item.Details.Product = Object.assign({}, item.Details.Product, quoteItem.Product);
      }
    }
    return item;
  }));
};
export var removeQuantities = function removeQuantities(items) {
  var clonedItems = clone(items);
  if (clonedItems.length) {
    clonedItems.forEach(function (item) {
      delete item.Quantity;
      delete item.existingQuantity;
    });
  }
  return clonedItems;
};